import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import clsx from 'clsx';

export type H2Props = ComponentPropsWithoutRef<'h2'> & {
    className?: string;
    children: ReactNode;
};

function H2({ className = '', children, ...restProps }: H2Props) {
    return (
        <h2 className={clsx('font-GBold text-3.5xl', className)} {...restProps}>
            {children}
        </h2>
    );
}

export default H2;
